export default __webpack_public_path__ + "static/media/53.53d976fe.png";